export default __webpack_public_path__ + "static/media/notif_article_sent_back.f0f0fd7a.svg";